module.exports = __webpack_public_path__ + "img/hmn.a4e3b886.svg";